import * as yup from 'yup';
import { BooleanSchema } from 'yup';
import { UserValidation } from '../../../../types';

export interface BooleanValdiation extends Pick<UserValidation, 'required' | 'min' | 'max'> {}

// build validation for booleans
export const buildBooleanValidators = ({ required }: BooleanValdiation) => {
  let schema: BooleanSchema<boolean | undefined | null, object> = yup.boolean();
  // if boolean based component is required it means it accepts only "true" value
  if (required)
    schema = schema
      .required(...required)
      .oneOf([true], required?.[0])
      .nullable();
  return schema;
};
